import { Service } from "../../../core/impl/Service";
import { NetworkInstancesManager } from "../../../networkinstances/impl/manager/NetworkInstancesManager";
import { IService } from "../../../core/api/IService";
import { BranchesManager } from "../manager/BranchesManager";
import { BranchesXMLParser } from "../parser/BranchesXMLParser";
import { Branch } from "../model/Branch";
import { Context } from "../../../core/impl/Context";
import { getLogger } from "@goodgamestudios/logger";
import { WorldAssignmentTrackingConstants } from "../../../TrackingConstants";
import { WorldAssignmentError } from "../../../error/WorldAssignmentError";
import { WorldAssignmentErrorCodes } from "../../../error/WorldAssignmentErrorCodes";

const logger = getLogger("WorldAssignment.BranchesController");

export class BranchesController {
    private service: IService;
    private manager: BranchesManager;

    protected initialize() {
        this.service = new Service(Context.instance.globals.branchesConfigUrl);
        this.manager = Context.instance.get(BranchesManager);
    }

    public dispose() {
        if (this.service) {
            this.service.dispose();
            this.service = null;
        }
    }

    public async loadBranches(trackingCallback?: (state: string) => void): Promise<void> {
        logger.debug("loadBranches");
        if (trackingCallback) {
            trackingCallback(WorldAssignmentTrackingConstants.BRANCH_XML_START);
        }
        return this.service.load()
            .then((payload) => {
                if (trackingCallback) { trackingCallback(WorldAssignmentTrackingConstants.BRANCH_XML_END); }
                this.manager.branches = BranchesXMLParser.parse(payload);
            })
            .catch(() => {
                throw new WorldAssignmentError(
                    WorldAssignmentErrorCodes.BRANCHES_FAILED_TO_LOAD,
                    "Failed to load branches.xml from " + Context.instance.globals.branchesConfigUrl
                );
            });
    }

    public initializeBranch = async () => {
        logger.debug("initializeBranch");
        let zoneId: string;
        // TODO FIXME  we should just initialize branch using value from Instance that was selected by country detection ( or manually set from game )
        if (Context.instance.globals.zoneIdFromNetworkCookie > 0) {
            zoneId = Context.instance.globals.zoneIdFromNetworkCookie.toString();
        } else {
            zoneId = (<NetworkInstancesManager>Context.instance.get(NetworkInstancesManager)).selectedNetworkInstance.zoneId.toString();
        }
        logger.debug('zoneId:', zoneId);
        let branch: Branch = this.manager.getBranchByZoneId(zoneId);
        if (!branch) {
            logger.debug("could not find branch for zone id  " + zoneId + " will fallback to default ");
            branch = this.manager.getBranchByBranchId("default");
        }
        if (!branch) {
            throw new WorldAssignmentError(
                WorldAssignmentErrorCodes.BRANCHES_FAILED_TO_INITIALIZE,
                "BranchesController.initializeBranch: branch initialization failed"
            );
        }
        this.manager.currentBranch = branch;
    }
}
